import styled from '@emotion/styled';
import { calculateWidth, CarouselItemProps } from 'ds/components/carousels/cards-carousel/helpers';

export const ScrollXBox = styled.div<{ clipY?: boolean }>`
  display: flex;
  min-width: 0;
  display: flex;
  overflow-x: scroll;
  // opt-in: overflow-x:scroll makes the browser compute overflow-y as auto, which lets the strip
  // scroll/drag vertically. clipY pins it to hidden so the strip only ever scrolls horizontally
  // (content within its own padding still shows — the clip is at the padding-box edge).
  ${({ clipY }) => clipY ? 'overflow-y: hidden;' : ''}
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar,
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    display: none;
  }
`;

export const ScrollXBoxWithCalculatedWidth = styled(ScrollXBox)<CarouselItemProps & { children: React.ReactNode; }>`
  & > div > div {
    width: ${calculateWidth};
    display: flex;
    flex-shrink: 0;
    padding: ${({ theme }) => theme.spacing(0.5)};
  }
`;

// the rule with ".thumbnail-logo" looks weired (why this container should know something about any class name?) -> should be refactored
export const ScrollXBoxPaddingContainer = styled.div<{ padding: string, supressCalculatedHeight: boolean }>`
  ${({ padding }) => `
    display: flex;
    ${padding ? `padding: ${padding};` : ''}
  `}
  ${({ theme, supressCalculatedHeight }) => theme.media.showAt({ at: 1 }) `
    a > div:not(.thumbnail-logo) {
      ${supressCalculatedHeight ? '' : `height: calc(100% - ${theme.spacing(1)});`}
      margin-top: ${theme.spacing(.5)};
    }
  `}
`;

export const ScrollXBoxContainer = styled.div<{ withOverflow: boolean }>`
  ${({ withOverflow }) => `
    min-width: 0;
    display: flex;
    ${withOverflow ? 'overflow: hidden;' : ''}
  `}
`;

export const ScrollXBoxWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    min-width: 0;
    overflow: hidden;
  `}
`;
